<!--  -->
<template>
  <van-popup v-model="isShow" @click-overlay="closePopup" position="bottom">
    <van-datetime-picker
      v-model="currentDate"
      type="year-month"
      :formatter="formatter"
      @cancel="closePopup"
      @confirm="confirmDate"
    />
  </van-popup>
</template>

<script>
import Vue from 'vue'
import { DatetimePicker, Popup } from 'vant'
Vue.use(DatetimePicker)
  .use(Popup)
export default {
  components: {},

  props: {
    show: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      currentDate: new Date(),
      isShow: this.show
    }
  },

  computed: {},

  watch: {
    show () {
      this.isShow = this.show
    }
  },

  created () {
    this.confirmDate()
  },

  methods: {
    closePopup () {
      this.$emit('update:show', false)
    },
    formatter (type, value) {
      if (type === 'year') {
        return `${value}年`
      } else if (type === 'month') {
        return `${value}月`
      }
      return value
    },
    confirmDate (value = new Date()) {
      var date = value
      var m = date.getMonth() + 1
      if (m >= 1 && m <= 9) {
        m = '0' + m
      }
      var timer = date.getFullYear() + '年' + m + '月'
      this.$emit('loadData', timer)
      this.closePopup()
    }
  }
}

</script>
<style lang='scss' scoped>

</style>
